module.exports = __webpack_public_path__ + "static/media/cu.ff754a33.svg";